import { SpocState } from './state';
import { RouterDidChangeAction } from '../index';

export const SET_SPOC = 'SET_SPOC';
export const SET_SPOCS = 'SET_SPOCS';
export const SET_SPOC_FINISHED = 'SET_SPOC_FINISHED';

export const SOFT_RESET = 'SOFT_RESET';

export const KC_FIND_USERS_REQUEST = 'KC_FIND_USERS_REQUEST';
export const KC_FIND_USERS_SUCCESS = 'KC_FIND_USERS_SUCCESS';
export const KC_FIND_USERS_FAILURE = 'KC_FIND_USERS_FAILURE';
export const KC_IMPERSONATE = 'KC_IMPERSONATE';

export interface SetSpoc {
    type: typeof SET_SPOC;
    payload: SpocState;
}

export interface SetSpocs {
    type: typeof SET_SPOCS;
    payload: ReadonlyArray<SpocState>;
}

export interface SetSpocFinished {
    type: typeof SET_SPOC_FINISHED;
}

export interface SoftReset {
    type: typeof SOFT_RESET;
}

export interface KeyCloakFindUsersRequest {
    type: typeof KC_FIND_USERS_REQUEST;
    payload: string | undefined;
}

export interface KeyCloakFindUsersSuccess {
    type: typeof KC_FIND_USERS_SUCCESS;
    payload: any;
}

export interface KeyCloakFindUsersFailure {
    type: typeof KC_FIND_USERS_FAILURE;
}

export interface KeyCloakImpersonate {
    type: typeof KC_IMPERSONATE;
    payload: any;
}

export type AuthenticationAction =
    | SetSpoc
    | SetSpocs
    | SetSpocFinished
    | SoftReset
    | KeyCloakFindUsersRequest
    | KeyCloakFindUsersSuccess
    | KeyCloakFindUsersFailure
    | KeyCloakImpersonate
    | RouterDidChangeAction;
